module.exports = __webpack_public_path__ + "1.5.0-unryo/img/kubernetes.c422f4f3.svg";